var SignInForm = require('./login-form/sign-in-form');
var SignUpForm = require('./login-form/sign-up-form');



var LoginFormView = Backbone.View.extend({
  template: 'modals.loginForm',

  initialize: function() {
    this.hasRendered = false;
    this.signInForm = new SignInForm();
    this.signInForm.parent = this;
    this.signUpForm = new SignUpForm();
    this.signUpForm.parent = this;
  },

  toggleSignupForm: function() {
    this.$el.find('.sign-in-form-container').hide();
    this.$el.find('.sign-up-form-container').show();
  },

  toggleSigninForm: function() {
    this.$el.find('.sign-in-form-container').show();
    this.$el.find('.sign-up-form-container').hide();
  },

  beforeRender: function() {

    this.setView('.sign-in-form-container', this.signInForm);
    this.setView('.sign-up-form-container', this.signUpForm);

    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {

    this.signInForm.render();

    this.toggleSigninForm();

    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', function(e) {
      bookedby.app.currentClient.set('password', null);
      bookedby.app.currentClient.set('passwordConfirm', null);

      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
        //$('.modal-backdrop').hide();
      } else {
        console.log('No parent, oh noes')
      }
    });
  },

  show: function() {
    this.signInForm.$email.val('');
    this.signInForm.$password.val('');
    this.signInForm.$message.val('');

    if(bookedby.app.currentClient.get("email") && bookedby.app.currentClient.get("email").length > 1) {
      this.signInForm.$email.val(bookedby.app.currentClient.get("email"));
      this.signInForm.$email.attr("disabled", true);
    }

    if(this.message) {
      this.signInForm.$message.text(this.message);
    }

    this.$el.modal('show');
    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
      //$('.modal-backdrop').hide();
    } else {
      console.log('No parent, oh noes')
    }
    setTimeout(_.bind(function() {
      this.signInForm.$email.focus();
      console.log('did focus...');
    }, this), 250);
  }


});

module.exports = LoginFormView;